<template>
  <v-app>
    <!-- Global Alert (if needed) -->
    <v-alert class="popAlert" v-if="displayAlert" :type="alertType" :color="color">
      <div style="text-align: center">{{ alertMessage }}</div>
      <template v-slot:close>
        <v-icon @click="closeAlert">mdi-close</v-icon>
      </template>
    </v-alert>

    <!-- Full-screen content area with no padding -->
    <v-main class="viewer-main">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ViewerLayout',
  computed: {
    ...mapGetters('alert', ['alertType', 'displayAlert', 'alertMessage', 'color']),
  },
  methods: {
    ...mapActions('alert', ['closeAlert']),
  },
};
</script>

<style scoped lang="scss">
.viewer-main {
  height: 100vh;
  padding: 0 !important;
  background-color: #ffffff;
}

.popAlert {
  position: fixed;
  bottom: 20px;
  z-index: 9000;
  width: 60%;
  left: calc((100% - 60%) / 2);
}
</style>
